import React from "react"
import { Button, Container, Typography, Box } from "@mui/material"
import { Refresh as RefreshIcon, ErrorOutline as ErrorIcon } from "@mui/icons-material"

class ErrorBoundary extends React.Component {
  state = { hasError: false, errorMessage: "" }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: error.message }
  }

  componentDidCatch(error, info) {
    console.error("Error caught in ErrorBoundary:", error, info)
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            textAlign: "center",
            backgroundColor: "#f4f6f8",
            color: "#1976d2",
          }}
        >
          <ErrorIcon sx={{ fontSize: 80, color: "#1976d2", mb: 2 }} />
          <Typography variant='h3' fontWeight='bold'>
            Oops! Something went wrong.
          </Typography>
          <Typography variant='body1' color='textSecondary' sx={{ mt: 1, mb: 3 }}>
            {this.state.errorMessage ||
              "An unexpected error occurred. Please try refreshing the page."}
          </Typography>
          <Button
            variant='contained'
            color='primary'
            startIcon={<RefreshIcon />}
            onClick={this.handleReload}
            sx={{ px: 4, py: 1.5, fontSize: "1rem", borderRadius: "8px" }}
          >
            Refresh Page
          </Button>
        </Box>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
